import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAtomValue } from 'jotai';

import { Popover, PopoverAnchor, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import useResizeObserver from '@/hooks/use-resize-observer';
import { cn } from '@/lib/utils';

import { roomTypeSettingsAtom } from '../../atoms/settings';
import { RoomTypeSelectionContent } from './room-type-selection-content';

export const RoomTypeSettings = () => {
  const roomType = useAtomValue(roomTypeSettingsAtom);
  const { t } = useTranslation();
  const isMobileView = !useResizeObserver(640);

  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover onOpenChange={setIsOpen} open={isOpen}>
      <PopoverTrigger asChild>
        <div>
          <div
            className={cn(
              'flex min-h-[40px] w-full cursor-pointer items-center justify-between gap-x-4 rounded-sm bg-[#EFF4F5] px-4 sm:hidden lg:flex',
              isOpen ? 'bg-primary-light' : 'bg-[#EFF4F5]'
            )}
          >
            <span className={cn('flex-1 text-left text-sm font-semibold', isOpen && 'text-white')}>
              {t('roomType')}
              <span aria-hidden>*</span>
              <span className="sr-only">{t('required')}</span>
            </span>
            {roomType ? (
              <span className={cn('text-right', isOpen && 'text-white')}>{t(roomType)}</span>
            ) : null}
          </div>
          <div
            className={cn(
              'hidden min-h-[26px] w-full cursor-pointer items-center justify-center rounded-sm bg-[#EFF4F5] px-2 sm:flex lg:hidden lg:px-4',
              isOpen ? 'bg-primary-light' : 'bg-[#EFF4F5]'
            )}
          >
            {roomType ? (
              <span className={cn('text-center text-xs', isOpen && 'text-white')}>
                {t(roomType)}
              </span>
            ) : (
              <span
                className={cn('flex-1text-center text-xs font-semibold', isOpen && 'text-white')}
              >
                {t('roomType')}
                <span aria-hidden>*</span>
                <span className="sr-only">{t('required')}</span>
              </span>
            )}
          </div>
        </div>
      </PopoverTrigger>
      {isMobileView ? <PopoverAnchor className="fixed top-0" /> : null}
      <PopoverContent
        className="h-screen w-screen overflow-hidden rounded-sm p-0 sm:h-auto sm:max-w-[476px]"
        side={isMobileView ? 'bottom' : 'right'}
        sideOffset={isMobileView ? 0 : 10}
      >
        <RoomTypeSelectionContent setPopoverOpen={setIsOpen} />
      </PopoverContent>
    </Popover>
  );
};
